import React from "react";
import { Modal } from "antd";
import axios from "axios";
import { toast } from "react-toastify";
import REACT_APP from "../../environment";
import { Button } from "antd";
import { useDispatch } from "react-redux";
import { endWait, startWait } from "../../store/waiting";
import { useTranslation } from "react-i18next";

const SubmitProduct = ({ product, isModalOpen, setIsModalOpen, getData }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const cancel = () => setIsModalOpen(false);

    const submit = async () => {
        dispatch(startWait());
        const data = { id: product.id };
        await axios
            .patch(`${REACT_APP.API_URL}/api/hrp/provider/v1/product/status/submit`, data, { headers: { Authorization: sessionStorage.getItem("token") } })
            .then(() => {
                getData();
                toast.success(t("Submitted!"));
                setIsModalOpen(false);
            })
            .catch((err) => {
                console.log(err);
                toast.error(t((err.response?.data?.errors && err.response.data.errors[0]?.message) || err.message));
            });
        dispatch(endWait());
    };

    return (
        <>
            <Modal title={t("Submit product")} open={isModalOpen} footer={[]} onCancel={cancel}>
                <div className="pt-4">
                    {t("Submit allows employees to subscribe to it. Are you sure you want to submit this product?")}
                    <div className="ant-modal-footer">
                        <Button onClick={cancel}>{t("Cancel")}</Button>
                        <Button type="primary" onClick={submit}>
                            {t("Submit")}
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
};
export default SubmitProduct;
